<template>
  <DiscountRatesTableWidget :assetTypes="assetTypes" :is-read-only-mode="isReadOnlyMode" :currencyCodes="currencyCodes" :currentDiscountRates="discountRates"></DiscountRatesTableWidget>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  async created() {
    await this.$store.dispatch('loadAllUnderlyingAssetTypes');
    await this.$store.dispatch('loadAllCurrencyCode');
    await this.$store.dispatch('discountRatesPlugin/loadAllDiscountRates');
    this.role = localStorage.getItem('role');
    if (this.role === 'Admin') {
      this.isReadOnlyMode = false;
    }
  },
  data() {
    return {
      isReadOnlyMode: true,
    };
  },
  computed: {
    ...mapGetters(['getUnderlyingAssetTypes']),
    ...mapGetters(['getCurrencyCode']),
    assetTypes() {
      return this.getUnderlyingAssetTypes;
    },
    currencyCodes() {
      return this.getCurrencyCode;
    },
    discountRates() {
      return this.$store.getters['discountRatesPlugin/getAllDiscountRates']
    }
  }
}

</script>
